export function isTokenExpired(
  expiresAt: number,
  gracePeriodSeconds = 30
): boolean {
  const now = Math.floor(Date.now() / 1000);
  return now >= expiresAt - gracePeriodSeconds;
}

export function calculateTokenExpiration(expiresIn: number): number {
  const now = Math.floor(Date.now() / 1000);
  return now + expiresIn;
}

export function getCurrentTimestamp(): number {
  return Math.floor(Date.now() / 1000);
}

export function getTimeUntilExpiration(expiresAt: number): number {
  const now = Math.floor(Date.now() / 1000);
  return expiresAt - now;
}

export function formatTimeRemaining(seconds: number): string {
  if (seconds <= 0) return "expired";

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  } else if (minutes > 0) {
    return `${minutes}m`;
  } else {
    return `${secs}s`;
  }
}

